/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { format } from 'date-fns';
import mbpLogger from 'mbp-logger';

import brandTheme from '../../../../../../components/AppShell/brandtheme';
import { setCurrencyFormatforTotalOrder } from './Sku-helper';
import { getCartAttributeByNameAndReturnValue } from '../../../../../../helpers/page/pageHelpers';
import { getFormatedDeliveryDate } from '../PmallShippingMethod/Helper/helper';

export const BreakPointToMobile = 997;
export const BreakPointSm = 699;

export const monthConverter = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    10: 'October',
    11: 'November',
    12: 'December',
};

export const getFlexMessage = (selectedFlexOption, type = '') => {
    // Get Flex Message from cart
    if (
        selectedFlexOption && selectedFlexOption.optionCode
        && selectedFlexOption.flexMsg
        && Object.keys(selectedFlexOption.flexMsg).length > 2
    ) {
        if (type === 'multioption') {
            return selectedFlexOption.flexMsg[2]; // payment type
        }
        return selectedFlexOption.flexMsg[3]; // confirmation type
    }
    return '';
};

const formatString = (str) => {
    if (str && str.length > 0) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return '';
};

export const getFormattedDate = (dateValue, formatType) => {
    let dateInfo = null;
    if (dateValue.includes(':')) {
        dateInfo = dateValue;
    } else {
        dateInfo = `${dateValue} 00:00:00`;
        if (new Date(dateInfo).toString() === 'Invalid Date') {
            // 15 IOS down have problem with dashes
            if (dateValue.includes('-')) {
                const dateSplit = dateValue.split('-');
                dateInfo = `${dateSplit[1]}/${dateSplit[2]}/${dateSplit[0]} 00:00:00`;
            }
        }
    }
    dateInfo = new Date(dateInfo);

    if (dateInfo.toString() !== 'Invalid Date') {
        dateInfo = format(new Date(dateInfo), formatType);
    } else {
        dateInfo = dateValue;
        mbpLogger.logError({
            function: 'getFormattedDate',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: `Invalid Date: ${dateValue}`,
        });
    }

    return dateInfo;
};

export const getArrivalDateText = (itemDetails, presentationFamily) => {
    if (presentationFamily === 'flower' || presentationFamily === '') {
        const objDeliveryDate = itemDetails.deliveryInfo?.deliveryDate ? new Date(itemDetails.deliveryInfo?.deliveryDate) : null;
        const txtDeliveryDate = objDeliveryDate ? format(new Date(objDeliveryDate), 'EEEE, MMMM do yyyy') : '';
        return txtDeliveryDate || 'Select a delivery date';
    }

    if (presentationFamily === 'food') {
        const { deliveryInfo, attributes } = itemDetails;
        if (attributes?.length > 0) {
            let arrivalMessage = getCartAttributeByNameAndReturnValue(attributes, 'ArrivalMessage');
            if (arrivalMessage && arrivalMessage.trim() !== 'Guaranteed by') {
                if (arrivalMessage.includes('Week')) {
                    const txtDeliveryDate = getFormattedDate(itemDetails.deliveryInfo?.deliveryDate, 'MMM. dd yyyy');
                    arrivalMessage = `Arrives Week of ${txtDeliveryDate}`;
                }
                return arrivalMessage;
            }
        }

        // Display Delivery Message with (between, on)
        if (deliveryInfo && deliveryInfo.deliveryDateType && deliveryInfo.deliveryDate) {
            if (deliveryInfo.deliveryDateType.toLowerCase() === 'between' && deliveryInfo.deliveryRangeStartDate) {
                const startDate = format(new Date(deliveryInfo.deliveryRangeStartDate), 'MMM dd');
                const endDate = format(new Date(deliveryInfo.deliveryDate), 'MMM dd, yyyy');
                return `${formatString(deliveryInfo.deliveryDateType)} ${startDate} - ${endDate}`;
            }

            return `${formatString(deliveryInfo.deliveryDateType)} ${getFormatedDeliveryDate(deliveryInfo.deliveryDate)}`;
        }

        if (deliveryInfo?.deliveryDate) {
            return getFormatedDeliveryDate(deliveryInfo.deliveryDate);
        }

        return 'Select a delivery date';
    }

    return '-';
};

export const getBrandProductFamily = (brandId) => {
    let presentationFamily = '';
    if (brandId) {
        const brandCode = Object.keys(brandTheme).filter((brand) => brandTheme[brand]?.id === brandId)[0];
        presentationFamily = brandTheme[brandCode]?.presentation_family || '';
    }

    return presentationFamily;
};

export const getFormattedDiscount = (discount) => {
    if (discount !== undefined) {
        const stringArr = setCurrencyFormatforTotalOrder(discount).toString().split('');
        if (stringArr[0] === '-') {
            stringArr.unshift('-');
            stringArr[1] = '$';
        }

        const stringValue = stringArr.join('');
        if (stringValue === '0.00') {
            return '$0.00';
        }
        return stringValue;
    }

    return '';
};

export const anchorToSection = (selectorInputToSearch = 'p[id*="helper-text-error-"]', top = 140, searchParent = true, timer = 200) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.body.scrollTo) {
        setTimeout(() => {
            if (selectorInputToSearch && document.querySelector(selectorInputToSearch)) {
                if (selectorInputToSearch === 'p[id*="helper-text-error-"]' && !searchParent) {
                    window.scrollTo(0, (document.querySelector(selectorInputToSearch).parentNode.parentNode.offsetTop + top));
                } else if (searchParent) {
                    window.scrollTo(0, (document.querySelector(selectorInputToSearch).parentNode.offsetTop - top));
                } else {
                    window.scrollTo(0, (document.querySelector(selectorInputToSearch).offsetTop - top));
                }
            }
        }, timer);
    }
};

export const anchorInputErrorMessage = (selectorId) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.body.scrollTo && selectorId) {
        let child = null;
        let parentPosition = null;
        setTimeout(() => {
            if (document.querySelector('p[id*="helper-text-error-"]')) {
                child = document.querySelector(`${selectorId} p[id*="helper-text-error-"]`);
                parentPosition = document.querySelector(`${selectorId}`);
            }

            if (parentPosition?.offsetTop && child?.parentNode?.offsetTop) {
                setTimeout(() => {
                    if (child.parentNode.offsetTop > parentPosition.offsetTop) {
                        window.scrollTo(0, (child.parentNode.offsetTop) - 140);
                    } else {
                        window.scrollTo(0, (parentPosition.offsetTop + child.parentNode.offsetTop) - 140); // Scroll to the common ErrorMessage
                    }
                }, 300);
            }
        }, 50);
    }
};

export const anchorErrorCommonMessage = (valueToRemove = 50) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.body.scrollTo) {
        let child = null;
        let parentPosition = null;
        // console.log('values 1:', document.querySelector('p[class*="InlineErrorMessage-errorMsg"]'));
        // console.log('values 2:', document.querySelector('span[class*="ErrorMessage-message-"]'));
        // console.log('values 3:', document.querySelector('*[class*="errorMessage"]'));
        // console.log('values 4:', document.querySelector('*[class*="inlineErrorMessage"]'));
        if (document.querySelector('span[class*="ErrorMessage-message-"]')) {
            child = document.querySelector('span[class*="ErrorMessage-message-"]');
            parentPosition = child.closest('div[id*="orderItem-"]');

            if (!parentPosition) {
                parentPosition = child.closest('div[id="paymentMethodsForm"]');
            }
        } else if (document.querySelector('p[class*="InlineErrorMessage-errorMsg"]')) {
            child = document.querySelector('p[class*="InlineErrorMessage-errorMsg"]');
            parentPosition = child.closest('div[id*="orderItem-"]');
        } else if (document.querySelector('*[class*="errorMessage"]')) {
            child = document.querySelector('*[class*="errorMessage"]');
            parentPosition = child.closest('div[id*="orderItem-"]');
        } else if (document.querySelector('*[class*="inlineErrorMessage"]')) {
            child = document.querySelector('*[class*="inlineErrorMessage"]');
            parentPosition = child.closest('div[id*="orderItem-"]');
        }
        // console.log('parentPosition:', parentPosition);
        // console.log('child:', child);
        if (parentPosition && child) {
            // console.log('parentPosition.offsetTop:', parentPosition.offsetTop);
            // console.log('child.parentNode.offsetTop:', child.parentNode.offsetTop);
            // console.log('valueToRemove:', valueToRemove);
            setTimeout(() => {
                window.scrollTo(0, child.parentNode.offsetTop - valueToRemove); // Scroll to the common ErrorMessage
                // window.scrollTo(0, (parentPosition.offsetTop + child.parentNode.offsetTop) - valueToRemove); // Scroll to the common ErrorMessage
            }, 500);
        }
    }
};

export const extCartAnchorErrorMsg = (bodyElement = '') => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.body.scrollTo) {
        let child = null;
        let parentPosition = null;

        if (document.querySelector('div[id*="error-message-"]')) {
            child = document.querySelector('div[id*="error-message-"]');
            parentPosition = child.closest('div[id*="itemRoot-"]');
        } else if (document.querySelector('div[class*="contErrorMessage"]')) {
            child = document.querySelector('div[class*="contErrorMessage"]').parentNode;
            parentPosition = child.closest('div[id*="itemRoot-"]');
        }

        if (parentPosition && child && bodyElement) {
            const elementToScroll = document.querySelector(bodyElement);
            if (elementToScroll) {
                setTimeout(() => {
                    elementToScroll.scrollTo(0, (parentPosition.offsetTop + child.parentNode.offsetTop) - 50); // Scroll to the common ErrorMessage
                }, 500);
            }
        }
    }
};
export const formattedDate = (date) => {
    if (date) {
        const originalDate = date?.split('T')[0];
        const reverseDate = originalDate?.split('-')?.reverse();
        reverseDate.splice(1, 0, reverseDate?.splice(0, 1)[0]);
        return reverseDate.join('-');
    }
    return '';
};

export const parseToStandarTimeFormat = (deliveryDateTime) => {
    let standardTime = '';
    if (deliveryDateTime) {
        let dateTime =  deliveryDateTime.split('T')?.[1] || '';
        if (dateTime) {
            dateTime = dateTime.substring(0, 5);

            const timeParts = dateTime.split(':');

            if (Number(timeParts[0]) > 12) {
                timeParts[0] = Number(timeParts[0]) - 12;
                standardTime = `0${timeParts.join(':')  } PM`.slice(-8);
            } else if (Number(timeParts[0]) === 12) {
                standardTime = `${timeParts.join(':')  } PM`;
            } else if (Number(timeParts[0]) === 0) {
                timeParts[0] = 12;
                standardTime = `${timeParts.join(':')  } AM`;
            } else {
                standardTime = `0${timeParts.join(':')  } AM`.slice(-8);
            }
        }
    }

    return standardTime;
};

export const cartStatusCompleteList = ['published', 'placed', 'paid', 'publishfailed', 'testcart'];

export function isPaymentOrReviewPage(pathname) {
    if (pathname.indexOf('/payment/') > 0 || pathname.indexOf('/review-order/') > 0) {
        return true;
    }

    return false;
}

export default {};
